export const fontFaces = [
  {
    family: 'SF Pro Text',
    weights: [
      {
        weight: 800,
        src: `url("../fonts/SF_Pro_Text/SFProText-Heavy.ttf"")`,
        format: 'truetype',
        options: {
          weight: '800',
          display: 'swap',
        },
      },
      {
        weight: 700,
        src: `url("../fonts/SF_Pro_Text/SFProText-Bold.ttf")`,
        format: 'truetype',
        options: {
          weight: '700',
          display: 'swap',
        },
      },
      {
        weight: 600,
        src: `url("../fonts/SF_Pro_Text/SFProText-Semibold.ttf")`,
        format: 'truetype',
        options: {
          weight: '600',
          display: 'swap',
        },
      },
      {
        weight: 500,
        src: `url("../fonts/SF_Pro_Text/SFProText-Medium.ttf")`,
        format: 'truetype',
        options: {
          weight: '500',
          display: 'swap',
        },
      },
      {
        weight: 400,
        src: `url("../fonts/SF_Pro_Text/SFProText-Regular.ttf")`,
        format: 'truetype',
        options: {
          weight: '400',
          display: 'swap',
        },
      },
    ],
    options: {
      display: 'swap',
      style: 'normal',
    },
  },
];
